<template>
  <div :class="componentClassName">
    <div class="m-automatic-responder-setting__header">
      <!-- <a-icon icon="sound" color="orange" /> -->
      {{ title }}
    </div>
    <div class="m-automatic-responder-setting__fields">
      <template
        v-if="
          responseMode === 'basic-voice-guidance' ||
          responseMode === 'voice-guidance' ||
          responseMode === 'voice-guidance-no-message'
        "
      >
        <!--        <m-form-input label="声色">-->
        <!--          <a-select-field-->
        <!--            v-model="currentVoice"-->
        <!--            class="m-automatic-responder-setting__voice-select"-->
        <!--            :options="voiceList"-->
        <!--            @change="handleVoiceChange"-->
        <!--          >-->
        <!--          </a-select-field>-->
        <!--        </m-form-input>-->
        <m-form-input label="ガイダンス内容">
          <template v-if="responseMode === 'basic-voice-guidance'">
            <a-text-field
              v-model="currentContent"
              class="m-automatic-responder-setting__content-input"
              type="textarea"
              rows="7"
              placeholder="お電話ありがとうございます。⚫︎⚫︎株式会社でございます。
音声ガイダンスに沿って、ご希望の番号を押してください。
商品の購入に関するお問い合わせは「1」を、商品の返品や交換に関するお問い合わせは「2」を、それ以外のお問い合わせは「3」を押してください。"
              :disabled="viewOnly"
              @change="handleContentChange"
            />
          </template>
          <template v-if="responseMode === 'voice-guidance'">
            <a-text-field
              v-model="currentContent"
              class="m-automatic-responder-setting__content-input"
              type="textarea"
              rows="7"
              :placeholder="voiceGuidancePlaceHolder"
              :disabled="viewOnly"
              @change="handleContentChange"
            />
          </template>
          <template v-if="responseMode === 'voice-guidance-no-message'">
            <a-text-field
              v-model="currentContent"
              class="m-automatic-responder-setting__content-input"
              type="textarea"
              rows="7"
              :placeholder="voiceGuidanceNoMessagePlaceHolder"
              :disabled="viewOnly"
              @change="handleContentChange"
            />
          </template>
        </m-form-input>
        <div class="m-form-input">
          <div class="m-automatic-responder-setting__button">
            <a-button
              v-show="!isVoicePlaying"
              id="play"
              variant="fill"
              color="primary"
              size="small"
              icon="play"
              icon-color="white"
              @click="handleTestButtonClick"
            >
              テスト再生
            </a-button>
            <a-button
              v-show="isVoicePlaying"
              id="stop"
              variant="fill"
              color="primary"
              size="small"
              icon="audio-pause"
              icon-color="white"
              @click="handleTestButtonClick('stop')"
            >
              テスト停止
            </a-button>
          </div>
        </div>
      </template>
      <template v-if="responseMode === 'transfer'">
        <m-form-input label="電話番号">
          <a-text-field
            id="phonenum"
            v-model="currentPhoneNumber"
            class="m-automatic-responder-setting__phone-input"
            type="tel"
            placeholder="0312345678"
            :disabled="viewOnly"
            @change="handlePhoneNumberChange"
          />
        </m-form-input>
      </template>
      <template v-if="(responseMode === 'voice-guidance-no-message' || responseMode === 'voice-guidance') && showEmail">
        <m-form-input>
          <a-switch
            v-model="currentEmailNotification"
            label="メール通知"
            :disabled="viewOnly"
            @change="handleEmailNotificationChange"
          />
          <a-text-field
            id="mailaddress"
            v-model="currentAbsenceMail"
            class="m-user-invitation-item__fields-email-input ml-20 mb-20"
            name="absenceMail"
            type="text"
            placeholder="xxxx@kaisha.co.jp"
            :disabled="!currentEmailNotification || viewOnly"
            @change="handleEmailChange"
          />
        </m-form-input>
        <a-caption-list>
          <li>
            メール通知とは営業時間外に着信があった場合、着信があった旨をお客様にメールで通知できる機能です。外線転送を選択されている場合はメール通知は適用されません。
          </li>
        </a-caption-list>
      </template>
      <template v-if="responseMode === 'voiceDX'">
        <m-form-input label="電話番号">
          <a-select-field
            v-model="currentPhoneNumber"
            class="mb-32"
            :options="voiceDXPhoneNumberList"
            :disabled="viewOnly"
            @change="handlePhoneNumberChange"
          />
        </m-form-input>
      </template>
    </div>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AButton from '@/components/atoms/button';
import AIcon from '@/components/atoms/icon';
import ASwitch from '@/components/atoms/switch';
import ATextField from '@/components/atoms/text-field';
import ASelectField from '@/components/atoms/select-field';
import MFormInput from '@/components/molecules/form-input';
import ACaptionList from '@/components/atoms/caption-list';

export default {
  name: 'm-automatic-responder-setting',
  components: {
    AButton,
    // AIcon,
    ASwitch,
    ASelectField,
    ATextField,
    MFormInput,
    ACaptionList,
  },
  props: {
    responseMode: {
      type: String,
      default: null,
      required: true,
      validator(value) {
        return value.match(/(basic-voice-guidance|voice-guidance|transfer|voiceDX)/);
      },
    },
    class: {
      type: String,
      default: '',
    },
    voiceList: {
      type: Array,
      default: new Array(0),
    },
    voice: {
      type: String,
      default: null,
    },
    content: {
      type: String,
      default: null,
    },
    phoneNumber: {
      type: String,
      default: null,
    },
    showEmail: {
      type: Boolean,
      default: false,
    },
    absenceMail: {
      type: String,
      default: null,
    },
    emailNotification: {
      type: Boolean,
      default: null,
    },
    voiceDXPhoneNumberList: {
      type: Array,
      default: new Array(0),
    },
    isVoicePlaying: {
      type: Boolean,
      default: false,
    },
    voiceGuidancePlaceHolder: {
      type: String,
      default: '',
    },
    voiceGuidanceNoMessagePlaceHolder: {
      type: String,
      default: '',
    },
    transferNumber: {
      type: String,
      default: null,
    },
    viewOnly: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'play',
    'stop',
    'update:voice',
    'update:content',
    'update:phoneNumber',
    'update:absenceMail',
    'update:emailNotification',
    'update:transferNumber',
  ],
  data() {
    return {
      currentVoice: '',
      currentContent: '',
      currentPhoneNumber: '',
      currentEmailNotification: false,
      currentAbsenceMail: '',
      currentVoiceDXNumberName: '',
      transferPhoneNumber: '',
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('m-automatic-responder-setting', this.responseMode);
      return `${baseClassName} ${this.class}`.trim();
    },
    title() {
      if (
        this.responseMode === 'basic-voice-guidance' ||
        this.responseMode === 'voice-guidance' ||
        this.responseMode === 'voice-guidance-no-message'
      ) {
        return '自動音声ガイダンスを設定';
      } else if (this.responseMode === 'transfer') {
        return '外線転送先設定';
      } else if (this.responseMode === 'voiceDX') {
        return 'COTOHA Voice DX Basic';
      }
      return '';
    },
  },
  watch: {
    voice(val, oldValue) {
      this.currentVoice = this.voice;
    },
    content(val, oldValue) {
      this.currentContent = this.content;
    },
    phoneNumber(val, oldValue) {
      if (this.responseMode !== 'voiceDX') {
        this.transferPhoneNumber = val; // 外線転送先設定にセットする用
      }

      this.currentPhoneNumber = this.phoneNumber;
    },
    absenceMail(val, oldValue) {
      this.currentAbsenceMail = this.absenceMail;
    },
    emailNotification(val, oldValue) {
      this.currentEmailNotification = this.emailNotification;
    },
  },
  mounted() {
    if (this.voiceList.length > 0 && this.currentVoice === '') {
      this.currentVoice = this.voiceList[0].value || '';
    }
    if (this.voice) {
      this.currentVoice = this.voice;
    }
    if (this.content) {
      this.currentContent = this.content;
    }
    if (this.voice) {
      this.currentPhoneNumber = this.phoneNumber;
    }
    if (this.absenceMail) {
      this.currentAbsenceMail = this.absenceMail;
    }
    if (this.emailNotification) {
      this.currentEmailNotification = this.emailNotification;
    }
  },
  methods: {
    handleVoiceChange(e) {
      this.$emit('update:voice', this.currentVoice);
    },
    handleContentChange(e) {
      this.$emit('update:content', this.currentContent);
    },
    handlePhoneNumberChange(e) {
      this.$emit('update:phoneNumber', this.currentPhoneNumber);
      this.$emit('update:transferNumber', this.transferPhoneNumber);
    },
    handleTestButtonClick(e) {
      if (e === 'stop') {
        return this.$emit('stop');
      }
      this.$emit('play', {
        voice: this.currentVoice,
        content: this.currentContent,
      });
      return '';
    },
    handleEmailChange() {
      this.$emit('update:absenceMail', this.currentAbsenceMail);
    },
    handleEmailNotificationChange() {
      if (!this.currentEmailNotification) {
        this.currentAbsenceMail = '';
        this.$emit('update:absenceMail', this.currentAbsenceMail);
      }
      this.$emit('update:emailNotification', this.currentEmailNotification);
    },
  },
};
</script>
